import React from "react";
import { IS_REF_MOBILE } from "../../../../utils/refViewport";

/**
 * Race 20 video title — reference markup (index.css `.casino-video-title`, `.race20 .total-points`):
 * .casino-video-title > span.casino-name " " .casino-video-rid " " .total-points (not when IS_MOBILE)
 */
export default function Race20VideoTitle({ title, roundId, totalCards, totalPoints }) {
  return (
    <div className="casino-video-title">
      <span className="casino-name">{title}</span>{" "}
      <div className="casino-video-rid">{`Round ID: ${roundId}`}</div>
      {!IS_REF_MOBILE && (
        <>
          {" "}
          <div className="total-points">
            <div>
              <div>Total Card:</div> <div>{totalCards}</div>
            </div>{" "}
            <div>
              <div>Total Point:</div> <div>{totalPoints}</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
